import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { ICommandHandler } from './command-handler-resolver.service';
import { MessageService } from '../message.service';
import { CommandBase, DeleteCommand, standardCommand } from '../../model/command';
import { LanguageService } from '../language.service';

// An updated version of DeleteCommandHandler that returns Observable<boolean> indicating success or cancellation of the delete action. This allows callers to react accordingly (e.g. refreshing data on successful deletion) - Atlan

@Injectable()
export class DeleteCommandHandlerV2 implements ICommandHandler {
  constructor(
    private _messageService: MessageService,
    private readonly _languageService: LanguageService
  ) {}

  private _deleteFromItemsSource(item: any, itemsSource: any[]) {
    if (!item || !itemsSource) return;

    const index = itemsSource.indexOf(item);
    if (index >= 0) itemsSource.splice(index, 1);
  }

  canExecute(command: CommandBase): boolean {
    if (command.id === standardCommand.delete) {
      if (command instanceof DeleteCommand) {
        return command.itemsSource.indexOf(command.context) >= 0;
      }
    }
    return false;
  }

  // Returns true only when deletion is confirmed and succeeds; false when cancelled or invalid
  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof DeleteCommand) {
      if (command.dataService) {
        return this._messageService
          .showDialog('DO_YOU_WANT_TO_DELETE_TEXT', { value: command.context.toString(this._languageService.currentLanguage) })
          .pipe(
            switchMap(dialogResult => {
              if (dialogResult) {
                return command.dataService.delete(command.context.id).pipe(
                  tap(() => this._deleteFromItemsSource(command.context, command.itemsSource)),
                  map(() => true)
                );
              }
              return of(false);
            })
          );
      } else {
        this._deleteFromItemsSource(command.context, command.itemsSource);
        return of(true);
      }
    }
    return of(false);
  }
}
